export const en = {
    translation: {
        'Booking System': 'Booking System',
        'Registration for Shabbat & Holidays': 'Registration for Shabbat & Holidays',
        'When will you be joining us':'When will you be joining us?',
        'register': 'Register',
        'Registration is quick and easy in a few simple steps': 'Registration is quick and easy in a few simple steps',
        'Back': 'Back',
        'Location': 'Location',
        'first_name': 'First Name',
        'last_name': 'Last Name',
        'email': 'Email',
        'phone': 'Phone',
        'I would like to donate': 'I would like to donate',
        'Your donation': 'Your Donation',
        'Payment Method': 'Payment Method',
        'Credit Card': 'Credit Card',
        'Cash Method': 'Cash',
        'total': 'Total',
        'continue': 'Continue',
        'Thank You' : 'Thank You',
        'Your order has been successfully received' : 'Your order has been successfully received',
        'places left' : 'Places left',
        'No spots available': 'No spots available',
        'coupon': 'Coupon',
        'off': 'off',
    }
}